import { render, staticRenderFns } from "./CertificationsTabInfo.vue?vue&type=template&id=f5697922&scoped=true&"
import script from "./CertificationsTabInfo.vue?vue&type=script&lang=js&"
export * from "./CertificationsTabInfo.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsTabInfo.vue?vue&type=style&index=0&id=f5697922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5697922",
  null
  
)

export default component.exports